import React from 'react'
import CustomCommandBarMenuItem from '../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';

import abilityBuild from '../../../shared/CASL/appAbility';
import { checkRoles } from '../../../hoc/CheckRoles';
import { AddEditUserAoo_Mode, RoleContext } from '../../../shared/enums';
import { RootState } from '../../../store';

import { Selection, CommandBar, DefaultButton, Dialog, DialogFooter, DialogType, IButtonProps, ICommandBarItemProps, ICommandBarStyles, IDialogContentProps, IPivotStyles, mergeStyleSets, PrimaryButton, MessageBar, MessageBarType } from '@fluentui/react';
import { connect, ConnectedProps } from 'react-redux';
import { IUser } from '../../../shared/interfaces';
import { Unsubscribe } from '@casl/ability';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { toastRef } from '../../Layout/Layout';
import UsersAooManagerTable from './UsersAooManagerTable';
import usersAooService from '../../../services/usersAoo.service';
import AddEditPanel from './AddEditPanel';


const classNames = mergeStyleSets({
    overFlowHidden: {
        overflow: 'hidden'
    },
    detailsListRow: {
        '.ms-DetailsRow-check': {
            height: '100%',
            width: 36
        },
        '.ms-DetailsRow-fields .ms-DetailsRow-cell': {
            paddingLeft: 0
        }
    }
});

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' },
};
const pivotBarStyles: Partial<IPivotStyles> = {
    root: { padding: '0 24px' },
    itemContainer: { overflow: 'hidden', height: '100%' }
};

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};


const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    isMobile: state.sessionReducer.isMobile,
    arxeiaConfigurations: state.sessionReducer.arxeiaConfigurations,
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface UsersAooManagerProps {

}

type Props = UsersAooManagerProps & RouteComponentProps & PropsFromRedux;

export interface UsersAooManagerState {
    commandBarItems: ICommandBarItemProps[],
    selectedUser?: IUser,
    lateralPanelIsOpen: boolean,
    lateralPanelBodyContent: Function,
    lateralPanelSubmitFunction: Function,
    confirmDialogIsOpen: boolean,
    confirmDialogContentProps: IDialogContentProps,
    confirmDialogSubmitFunction: Function,
    loadingUsersList: boolean,
    forceUsersAooManagerTableRefresh: boolean,
    allUsers: IUser[],
    showMessageBar: boolean,
    userMessageError: string,
}


class UsersAooManager extends React.Component<Props, UsersAooManagerState> {
    unsubscribeFromAbility: Unsubscribe = () => { };
    private userSelection: Selection;

    constructor(props) {
        super(props);


        this.userSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.userSelection.getSelection()[0] as IUser;
                this.setState({ selectedUser: selection })
            }
        })

        this.state = {
            commandBarItems: [],
            lateralPanelIsOpen: false,
            lateralPanelBodyContent: () => { },
            lateralPanelSubmitFunction: () => { },
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => { },
            loadingUsersList: false,
            forceUsersAooManagerTableRefresh: false,
            allUsers: [],
            showMessageBar: false,
            userMessageError: "",
        }

    }

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            if (abilityBuild.cannot('create', 'IUser')) {
                this.props.history.push({ pathname: '/unauthorized' });
            }
            this.updateCommandBarItems();
        });

        if (this.props.currentAoo) {
            this.updateCommandBarItems();
        }
    }

    componentDidUpdate(oldProps: Props, oldState: UsersAooManagerState) {

        if (oldProps.currentAoo !== this.props.currentAoo ||
            oldState.selectedUser !== this.state.selectedUser) {
            this.updateCommandBarItems();
        }
    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
    }

    updateCommandBarItems = () => {

        let newCommandBarItems: ICommandBarItemProps[] = [];
        if (abilityBuild.can('create', 'IUser'))
            newCommandBarItems.push(
                {
                    key: 'addUserAooManager',
                    iconProps: { iconName: 'AddFriend' },
                    text: 'Aggiungi utente',
                    onClick: this.addUserAooManagerHandler
                });

        if (abilityBuild.can('update', 'IUser') && this.state.selectedUser)
            newCommandBarItems.push({
                key: 'editUserAooManager',
                iconProps: { iconName: 'EditContact' },
                text: 'Modifica utente',
                onClick: this.editUserAooManagerHandler
            });


        this.setState({ commandBarItems: newCommandBarItems });
    }


    // Click sul button della commandbar - Aggiungi utente
    addUserAooManagerHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditPanel
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Nuovo utente'
                    loading={false}
                    onSubmit={this.addUserLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsEdit={false}
                    peopleList={this.state.allUsers}
                />
            }
        );
        this.userSelection.setAllSelected(false);
    }

    // Click su salva del panel laterale - Aggiungi utente
    addUserLateralPanelSubmit = (userItem: IUser) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi aggiungere un nuovo utente?',
            },
            confirmDialogSubmitFunction: () => { this.addUserConfirmDialogSubmit(userItem) }
        })
    }

    // Click su conferma del confirm dialog - Aggiungi utente
    addUserConfirmDialogSubmit = (userItem: IUser) => {
        if (this.props.currentAoo) {
            this.setState({ loadingUsersList: true });
            let { forceUsersAooManagerTableRefresh } = this.state

            usersAooService.addUserAoo(this.props.currentAoo.id, userItem)
                .then(result => {
                    this.setState({ forceUsersAooManagerTableRefresh: !forceUsersAooManagerTableRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: userItem!.displayName,
                        detail: `Utente aggiunto correttamente`,
                        life: 5000
                    });
                })
                .catch(error => {
                    this.setState({ loadingUsersList: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: userItem!.displayName,
                            detail: `Inserimento dell'utente non riuscito`,
                            life: 5000
                        });
                    }
                })

            this.setState({ confirmDialogIsOpen: false })
        }
    }

    // Click sul button della commandbar - Modifica utente
    editUserAooManagerHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditPanel
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Modifica utente'
                    loading={false}
                    selectedUser={this.state.selectedUser}
                    onSubmit={this.editUserLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsEdit={true}
                    peopleList={this.state.allUsers}
                />
            }
        );
    }

    // Click su salva del panel laterale - Modifica utente
    editUserLateralPanelSubmit = (userItem: IUser, addEditUserMode: AddEditUserAoo_Mode) => {
        let { selectedUser } = this.state;
        if (selectedUser) {
            this.setState({
                lateralPanelIsOpen: false,
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: `Vuoi modificare l'utente ${selectedUser.displayName}?`,
                },
                confirmDialogSubmitFunction: () => { this.editUserConfirmDialogSubmit(userItem, addEditUserMode) }
            })
        }
    }

    // Click su conferma del confirm dialog - Modifica utente
    editUserConfirmDialogSubmit = (userItem: IUser, addEditUserMode: AddEditUserAoo_Mode) => {
        if (this.props.currentAoo) {
            this.setState({ loadingUsersList: true });
            let { forceUsersAooManagerTableRefresh } = this.state

            usersAooService.updateUserAoo(this.props.currentAoo.id, userItem, addEditUserMode)
                .then(result => {
                    this.setState({ forceUsersAooManagerTableRefresh: !forceUsersAooManagerTableRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: userItem!.displayName,
                        detail: `Utente aggiornato correttamente`,
                        life: 5000
                    });
                })
                .catch(error => {
                    this.setState({ loadingUsersList: false });
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: userItem!.displayName,
                            detail: `Aggiornamento dell'utente non riuscito`,
                            life: 5000
                        });
                    }
                });

            this.setState({ confirmDialogIsOpen: false });
            this.userSelection.setAllSelected(false);
        }
    }


    dismissLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ lateralPanelIsOpen: false })
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }

    onSelectUserAooManagerHandler = (selected) => {
        this.setState({ selectedUser: selected })
    }

    render() {

        return (
            <React.Fragment>

                {this.state.lateralPanelBodyContent()}

                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>
                </Dialog>

                <div className="users-manager-component" >

                    {this.state.commandBarItems.length > 0 &&
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.commandBarItems}
                            styles={commandBarStyles}
                        />
                    }
                    {this.state.showMessageBar &&
                        <MessageBar
                            messageBarType={MessageBarType.blocked}
                            isMultiline={true}
                            onDismiss={() => this.setState({ showMessageBar: false })}
                            dismissButtonAriaLabel="Close">
                            {this.state.userMessageError}
                        </MessageBar>
                    }


                    <UsersAooManagerTable
                        loadingUsersAooManagerTable={this.state.loadingUsersList}
                        userSelection={this.userSelection}
                        forceTableRefresh={this.state.forceUsersAooManagerTableRefresh}
                        onSelectUsersAooManagerHandler={(selected) => this.onSelectUserAooManagerHandler(selected)}
                        editUserAooManagerHandler={this.editUserAooManagerHandler!}
                    />


                </div>

            </React.Fragment >
        )
    }
}

export default connector(withRouter(checkRoles(UsersAooManager, RoleContext.Aoo)));
